import React from "react";
import cross from "../../images/icons/cross.svg";
export default class GameWindowHeader extends React.Component{
    render() {
        let style = {
            width: this.props.width,
            height: this.props.height,
            background: `linear-gradient(180deg, ${this.props.colorStart ?? "#56CCF2"} 0%,${this.props.colorEnd ?? "#2D9CDB"} 100%)`,
            display: "flex",
            position: "relative",
            borderRadius: "3px 3px 0 0"
        }
        let textStyle = {
            position: "relative",
            top: `${this.props.positionTop ?? 12}px`,
            left: `${this.props.positionLeft ?? 10}px`,
            fontWeight: this.props.fontWeight ?? "bold",
            color: "black",
            fontSize: `${this.props.fontSize ?? 14}px`,
            lineHeight: `${this.props.lineHeight ?? (this.props.fontSize ?? 14)}px`,
            textTransform: "uppercase",
            textShadow: "0px 1px 1px rgba(0, 0, 0, 0.5)"
        }
        let iconStyle = {
            width: `${this.props.iconSize ?? 10}px`,
            height: `${this.props.iconSize ?? 10}px`,
            padding: "5px"
        }
        let currencyStyle = {
            position: "absolute",
            display: "flex",
            right: "40px",
            top: "10px"
        }
        return <div style={style} title={this.props.tooltip} onClick={this.props.onClick}>
            {this.props.icon ? <img src={this.props.icon} alt={"icon"} style={iconStyle}/> : ""}
            <div style={textStyle}>
              {this.props.title}
            </div>
            <div style={this.props.currencyStyle ?? currencyStyle}>
                {this.props.currencyBlocks}
            </div>
            {this.props.isClosable && this.props.onHide ? <img alt={'close'} className="in-game-popup-header-icon" style={
                {
                    right: `${this.props.height / 4}px`,
                    top: `calc(50% - ${this.props.height / 4 / 2}px)`,
                }
            } src={cross} onClick={this.props.onHide} /> : ""}
            {this.props.customContent}
        </div>
    }
}
